import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISlotList } from '../../../Pages/Slot/ISlot';

interface IUpdate extends IReduxState<ISlotList> {
  fixupdateableDate?: ISlotList;
}

export const UpdateFixtureOrderSlicer = createSlice({
  name: 'UpdateFixtureOrder',
  initialState: {
    data: {},
    isLoading: false,
    updateableData: {},
  } as IUpdate,
  reducers: {
    updateFixtureOrder: (state, _) => {
      state.isLoading = true;
    },
    successUpdateFixtureOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateFixtureOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    FixturesUpdateableDataOrder: (state, action) => {
      state.fixupdateableDate = action.payload;
    },
    clearUpdateFixtureStateOrder: (state) => {
      state.data = {};
      state.fixupdateableDate = undefined;
    },
    clearUpdateableDataOrder: (state) => {
      state.fixupdateableDate = undefined;
    },
  },
});

export const {
  updateFixtureOrder,
  failureUpdateFixtureOrder,
  successUpdateFixtureOrder,
  FixturesUpdateableDataOrder,
  clearUpdateFixtureStateOrder,
  clearUpdateableDataOrder,
} = UpdateFixtureOrderSlicer.actions;

export default UpdateFixtureOrderSlicer.reducer;
